import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Form, Col, Row, Button } from 'react-bootstrap';
import { ResetPasswordForm } from './ResetPasswordForm';
import './ResetPassword.css';

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [validated, setValidated] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const token = searchParams.get('token');

  const api = process.env.REACT_APP_IDP_PROVIDER;
  const resetPasswordEndpoint = `${api}/account/forgotpassword`;

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity()) {
      const email = form.email.value;
      const emailExists = await forgotPassword(email);

      setValidated(true);
      setShowSuccess(emailExists);
      setShowError(!emailExists);
    } else {
      setValidated(true);
    }
  };

  const forgotPassword = async (email) => {
    try {
      const response = await fetch(resetPasswordEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        const result = await response.json();
        return result; // Assuming `result` indicates email existence
      } else {
        return false; // Email not found or other error
      }
    } catch (error) {
      console.error("Error sending reset password request:", error);
      return false; // Return false on error to trigger showError
    }
  };

  return (
    <div className='container'>
      <Row>
        <Col className='reset-container' md="6">
          {token ? (
            <ResetPasswordForm />
          ) : (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Label>Please submit your email address below to receive reset instructions.</Form.Label>
              <Row>
                <Col md="9">
                  <Form.Control name='email' type="email" placeholder="Email" required />
                  <Form.Control.Feedback type='invalid'>User email is required.</Form.Control.Feedback>
                </Col>
                <Col md="3">
                  <Button variant="reset" type="submit">Reset</Button>
                </Col>
              </Row>

              {showSuccess && (
                <Row>
                  <Col md="12">
                    <div className="reset-success">
                      <span>Reset instructions have been emailed to you.</span>
                    </div>
                  </Col>
                </Row>
              )}

              {showError && !showSuccess && (
                <Row>
                  <Col md="12">
                    <div className="reset-failure">
                      <span>No account was found for that email address.</span>
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </Col>
      </Row>
    </div>
  );
};
